import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import R from 'ramda';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import CardoGroup from '@cotyorg/ccx-organism-cardo-group/components/CardoGroup';
import Heading from '@cotyorg/ccx-atoms/Heading';
import StandardLayout from '../../templates/StandardLayout';
import { cardsSectionBreakpointConfig } from './cardo.config';
import { horizontalLayoutConfig } from './horizontalLayout.config';

const NewComponent = ({ products, shouldUseBazaar, productCountText }) => (
  <StandardLayout>
    <div className="new-hero">
      <div className="grid-container new-hero__wrapper">
        <div className="grid-x">
          <div className="cell xsmall-16 large-14 large-offset-1">
            <HeroFullBlock
              heroStoreDataKey="heroSection1"
              isUnderlined={false}
              horizontalConfig={horizontalLayoutConfig}
            />
          </div>
        </div>
      </div>
    </div>

    {R.length(products) > 1 && productCountText && (
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16 large-14 large-offset-1">
            <div className="new-products-heading-section">
              <Heading level={5}>
                {R.length(products)} {productCountText}
              </Heading>
            </div>
          </div>
        </div>
      </div>
    )}

    <div className="product-list">
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16 large-14 large-offset-1">
            <div className="grid-x grid-padding-x flex-container">
              <CardoGroup
                showStarRating={shouldUseBazaar}
                data="products"
                isTitleUnderlined={false}
                contentTheme="transparent"
                headingLevel={5}
                fitImageToCard
                imgRatingOnSrc={{
                  fullStar: '/ccx-files/assets/star-on.svg',
                  partialStar1: '/ccx-files/assets/partial-star-1.svg',
                  partialStar2: '/ccx-files/assets/partial-star-2.svg',
                  partialStar3: '/ccx-files/assets/partial-star-3.svg',
                  partialStar4: '/ccx-files/assets/partial-star-4.svg',
                  partialStar5: '/ccx-files/assets/partial-star-5.svg',
                  partialStar6: '/ccx-files/assets/partial-star-6.svg',
                  partialStar7: '/ccx-files/assets/partial-star-7.svg',
                  partialStar8: '/ccx-files/assets/partial-star-8.svg',
                  partialStar9: '/ccx-files/assets/partial-star-9.svg',
                }}
                imgRatingOffSrc="/ccx-files/assets/star-off.svg"
                baseBreakpointConfig={cardsSectionBreakpointConfig}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

NewComponent.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  shouldUseBazaar: PropTypes.bool,
  productCountText: PropTypes.string,
};

export default connect(({ content }) => ({
  products: R.path(['cardoGroup', 'products'], content),
  shouldUseBazaar: R.prop('shouldUseBazaar')(content),
  productCountText: R.prop('productCountText', content),
}))(NewComponent);
